// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NH8A","col":"styles_col__cs-W1"};